export enum ReactionsNamesEnum {
    LIKE = "like",
    LOVE = "love",
    LAUGH = "laugh",
    HUSHED = "hushed",
    ANGRY = "angry",
    SAD = "sad",
    DISLIKE = "dislike",
}

export enum ReactionsButtonTextMapper {
    like = "Gefällt mir",
    love = "Herz",
    laugh = "Lustig",
    hushed = "Wow",
    angry = "Wütend",
    sad = "Traurig",
    dislike = "Gefällt nicht",
}

export enum ReactionsButtonColorMapper {
    like = "var(--community-reaction-like-color)",
    love = "var(--community-reaction-love-color)",
    laugh = "var(--community-reaction-laugh-color)",
    hushed = "var(--community-reaction-hushed-color)",
    sad = "var(--community-reaction-sad-color)",
    dislike = "var(--community-reaction-dislike-color)",
}
